export default "__VITE_ASSET__CpHwU73P__"